import React, { useEffect, useState } from "react";
import { BED_HEIGHT, BED_WIDTH } from "../../ward/map/mapState";
import { useTheme } from "@mui/material/styles";
import _ from "lodash";
import AgyleLoadingSpinner from "../../../components/other/agyleLoadingSpinner";
import API from "../../../app/api";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../store/reducers/globals";

const WardCardThumbnail = ({
  escalationLevel,
  wardId,
  elements = [],
  width,
  height,
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [beds, setBeds] = useState([]);
  const currentEscalationLevel =
    escalationLevel && escalationLevel?.find((el) => el.wardId === wardId);

  useEffect(() => {
    setIsLoading(true);
    API.getAllBeds(wardId)
      .then((res) => {
        setBeds(res?.data);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [wardId]);

  const filterBedsByEscalationLevel = (bed) => {
    if (!bed || !currentEscalationLevel) return true;

    switch (currentEscalationLevel?.level) {
      case "core":
        return bed?.subtype === "core";
      case "planned":
        return bed?.subtype === "core" || bed?.subtype === "planned";
      case "unplanned":
      default:
        return true;
    }
  };

  if (elements.length === 0) return null;

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <AgyleLoadingSpinner disableText />
      </div>
    );
  }

  return (
    <svg
      fill="red"
      width="100%"
      height="100%"
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMidYMid meet"
    >
      {elements.map((element) => {
        const bed = beds?.find((b) => b?.__id === element?.bedId);
        const showBed = filterBedsByEscalationLevel(bed);
        if (!showBed) return null;

        return (
          <rect
            key={element.uniqId}
            x={Number(element.x)}
            y={Number(element.y)}
            width={
              !_.isEmpty(element?.width) && element?.width !== "0"
                ? Number(element.width)
                : BED_WIDTH
            }
            height={
              !_.isEmpty(element?.height) && element?.height !== "0"
                ? Number(element.height)
                : BED_HEIGHT
            }
            fill={theme.palette.mode === "light" ? "#a4a4a4" : "#f0f0f0"}
          />
        );
      })}
    </svg>
  );
};

export default React.memo(WardCardThumbnail);
